module.exports = __webpack_public_path__ + "static/img/first-page.58c7f9e3.svg";